import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M14 7C14 8.87687 13.2613 10.5812 12.0589 11.8382C10.7889 13.1657 9.0017 13.9942 7.02089 14C7.01393 14 7.00697 14 7 14C6.99303 14 6.98607 14 6.97911 14C4.9983 13.9942 3.21106 13.1657 1.94113 11.8382C0.738659 10.5812 0 8.87687 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7ZM11.2428 10.5C10.2341 9.27847 8.70794 8.49997 7 8.49997C5.29206 8.49997 3.76594 9.27847 2.75715 10.5C3.76594 11.7215 5.29206 12.5 7 12.5C8.70794 12.5 10.2341 11.7215 11.2428 10.5ZM7.00012 7.49997C8.38083 7.49997 9.50012 6.38068 9.50012 4.99997C9.50012 3.61926 8.38083 2.49997 7.00012 2.49997C5.61941 2.49997 4.50012 3.61926 4.50012 4.99997C4.50012 6.38068 5.61941 7.49997 7.00012 7.49997Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }